export default "__VITE_ASSET__eWnL$MBO__"